import React, { useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
// @ts-ignore: allow side-effect CSS import without module declarations
import "react-toastify/dist/ReactToastify.css";
import EditMenu from "./EditMenu";
import StaffToolbar from "./staff/components/StaffToolbar";
import StaffTableSection from "./staff/components/StaffTableSection";
import StaffDialogs from "./staff/components/StaffDialogs";
import { useStaffData } from "./staff/hooks/useStaffData";
import { useStaffPagination } from "./staff/hooks/useStaffPagination";
import { useStaffHandlers } from "./staff/hooks/useStaffHandlers";
import { PageTitle } from "src/shared/PageTitle";
import { pageTitle } from "src/shared/utils/brand";
import { useUserTheme } from "src/shared/utils/useUserTheme";
const MENU_CONFIG = {
  staff: "Category",
};
const StaffPage: React.FC = () => {
  const [showDeletedStaffs, setShowDeletedStaffs] = useState(false);
  const { staffData, loading, error, refetch } = useStaffData(showDeletedStaffs);
  const { searchQuery, filteredData, handleChangePage, handleChangeRowsPerPage, handleSearch } = useStaffPagination(staffData);

  const {
    addDialogOpen,
    editDialogOpen,
    deleteDialogOpen,
    selectedStaff,
    deleteStaffName,
    handleAddStaff,
    handleUpdateStaff,
    handleDeleteStaff,
    handleEditClick,
    handleDeleteClick,
    setAddDialogOpen,
    setEditDialogOpen,
    setDeleteDialogOpen,
    setSelectedStaff,
  } = useStaffHandlers(staffData, refetch);
  const { sidebarThemeClass } = useUserTheme();

  useEffect(() => {
    document.title = pageTitle("Staff › Settings");
  }, []);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;

  return (
    <div className="p-1">
      <ToastContainer />

      {/* Main Content */}
      <div className={`flex flex-col w-full h-[91vh] shadow-inner rounded-lg items-center ${sidebarThemeClass} overflow-hidden`}>
        <PageTitle title="- Settings › Staff" />
        <EditMenu editmenu={MENU_CONFIG} />

        {/* Toolbar */}
        <StaffToolbar
          showDeletedStaffs={showDeletedStaffs}
          onToggleDeleted={() => setShowDeletedStaffs(!showDeletedStaffs)}
          searchQuery={searchQuery}
          onSearch={handleSearch}
          onAddClick={() => setAddDialogOpen(true)}
        />

        {/* Staff Table Section */}
        <StaffTableSection
          staffData={staffData}
          filteredData={filteredData}
          onEdit={handleEditClick}
          onDelete={handleDeleteClick}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          showDeletedStaffs={showDeletedStaffs}
        />

        {/* Dialogs */}
        <StaffDialogs
          addDialogOpen={addDialogOpen}
          editDialogOpen={editDialogOpen}
          deleteDialogOpen={deleteDialogOpen}
          selectedStaff={selectedStaff}
          deleteStaffName={deleteStaffName}
          onCloseAdd={() => setAddDialogOpen(false)}
          onCloseEdit={() => {
            setEditDialogOpen(false);
            setSelectedStaff(null);
          }}
          onCloseDelete={() => {
            setDeleteDialogOpen(false);
            setSelectedStaff(null);
          }}
          onAddStaff={handleAddStaff}
          onUpdateStaff={handleUpdateStaff}
          onDeleteStaff={handleDeleteStaff}
        />
      </div>
    </div>
  );
};

export default StaffPage;
